module.exports = __webpack_public_path__ + "static/img/quote-icon.5e36f9cd.svg";